import { useBreakpoints } from '@phoenix/design-system/frontend/ui/breakpoints/use-breakpoints';
import { cx } from '@emotion/css';
import { useTranslation } from 'next-i18next';
import { useDealerNps } from '../hooks/use-dealer-nps.hook';
import { HookFormBaseForm } from '../../hook-form/hook-form-base-form/hook-form-base-form';
import { useDealerMapContext } from '../context/dealer-map-context';
import { DSButton, DSHeading, DSNotification, DSRadioGroup, DSText, DSTextarea } from '@stihl-design-system/components';
import { Controller } from 'react-hook-form';
import { RangeSlider } from '@phoenix/design-system/frontend/ui/range-slider/range-slider';

const DealerNpsForm = ({ enabled }: { enabled: boolean }) => {
  const { t } = useTranslation(['shared']);
  const { selectedDealer } = useDealerMapContext();
  const { desktop } = useBreakpoints();
  const { formProps } = useDealerNps({ dealer: selectedDealer });

  if (!selectedDealer?.id || !enabled) {
    return null;
  }

  return (
    <section data-testid="dealer-details_nps">
      <HookFormBaseForm {...formProps} className="mt-4">
        {formProps.methods.formState.errors.value?.message && (
          <DSNotification data-test-id="errorNotification" variant="error" className="!mb-4">
            {formProps.methods.formState.errors.value?.message}
          </DSNotification>
        )}

        <Controller
          name="value"
          render={({ field }) => (
            <div>
              <div className={cx('mb-4 max-w-[25rem]', desktop ? 'block' : 'hidden')}>
                <DSRadioGroup
                  {...field}
                  description={t('shared_dealers_map_detail_nps_labelMetric')}
                  direction="horizontal"
                  id="npsScore"
                  legend={t('shared_dealers_map_detail_nps_headline')}
                  data-testid="dealer-details_nps-radio-group"
                  systemFeedback="This is a system feedback message"
                  options={Array.from({ length: 10 }).map((_, index) => ({
                    label: String(index + 1),
                    value: String(index + 1),
                  }))}
                />
              </div>
              <div className={cx('mb-4', desktop ? 'hidden' : 'block')}>
                <DSHeading size="small" tag="h3">
                  {t('shared_dealers_map_detail_nps_headline')}
                </DSHeading>
                <DSText size="small" className="mt-2">
                  {t('shared_dealers_map_detail_nps_labelMetric')}
                </DSText>

                <RangeSlider
                  onChange={(val) => {
                    field.onChange(String(val));
                  }}
                  value={field.value}
                  min={1}
                  max={10}
                  dots
                  data-testid="dealer-details_nps-slider"
                  className="mt-4"
                />
                <div className="mt-2 flex justify-between stihl-text-body-sm-bold">
                  <span>1</span>
                  <span>10</span>
                </div>
              </div>
            </div>
          )}
        />

        <Controller
          name="description"
          render={({ field }) => (
            <DSTextarea
              {...field}
              id="description"
              className="mt-2 h-32 w-full leading-4"
              label={t('shared_dealers_map_detail_nps_labelTextField')}
              maxLength={1000}
              data-testid="dealer_nps_message"
            />
          )}
        />

        <DSButton
          type="submit"
          className="!mt-2"
          aria-label={t('shared_dealers_map_detail_nps_button_send_aria', {
            dealer: selectedDealer.description,
          })}
        >
          {t('shared_dealers_map_detail_nps_button_send')}
        </DSButton>
      </HookFormBaseForm>
    </section>
  );
};
export { DealerNpsForm };
